export default __webpack_public_path__ + "static/payment-icons.img-8eb2ef6e81624a161b86953f9a0881ec.svg";